// extracted by mini-css-extract-plugin
export default {"container":"machine-relations-table_container__WAv5m","delete":"machine-relations-table_delete__pkjxH","table":"machine-relations-table_table__1FuNd"};